import {
  USER_LOADED, AUTH_ERROR,
  LOGIN_SUCCESS, LOGIN_FAIL,
  LOGOUT, TOKEN_EXPIRED,
} from '../actions/types';

const initialState = {
  [process.env.REACT_APP_TOKEN_NAME]: localStorage.getItem(process.env.REACT_APP_TOKEN_NAME),
  isAuthenticated:                    null,
  user:                               null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        user:            payload,
      };
    case LOGIN_SUCCESS:
      localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, payload.token);
      return {
        ...state,
        [process.env.REACT_APP_TOKEN_NAME]: payload.token,
        user:                               payload.user,
        isAuthenticated:                    true,
      };

    case TOKEN_EXPIRED:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
      return {
        ...state,
        [process.env.REACT_APP_TOKEN_NAME]: null,
        isAuthenticated:                    false,
        user:                               null,
        // we set token = null because
        // some user will still logged-in already when we release this PR
        // so token value is persisted in their browser , we need to clear token value when they logged out.
        // for our testing , we clear localStorage ourself , but user won't do like this. so we need to clear behalf of them.
        token:                              null,
      };
    default:
      return state;
  }
}
